<template>
  <div>
    <div>
      <Calendar :clientId="clientId" />
      <v-dialog
        width="1000px"
        v-if="showAdmRequest"
        v-model="showAdmRequest"
        persistent
      >
        <v-card>
          <v-flex class="row mx-3 my-2">
            <v-layout align-center>
              <v-spacer></v-spacer>
              <v-btn icon class="ma-0" @click="showAdmRequest = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-layout>
          </v-flex>
          <AdmRequest :clientId="clientId" />
        </v-card>
      </v-dialog>
    </div>
    <br />
    <div>
      <v-btn @click="showAdmRequest = true" color="success"
        >Criar Reserva</v-btn
      >
    </div>
  </div>
</template>

<script>
import Calendar from '../shared/Calendar';
import AdmRequest from '../tcs/AdmRequest';

export default {
  components: {
    Calendar,
    AdmRequest,
  },
  data() {
    return {
      showAdmRequest: false,
      clientId: Number(localStorage.getItem('client_id')),
    };
  },
};
</script>

<style>
.action {
  background-color: var(--orange-color);
}
</style>
